import { combineReducers } from 'redux';

import { getAccountingReports, exportAccountingReports, getParkingReport, exportOperationReports, getMembershipReport } from './Report';

import { getBuilding, getBuildingByRefNo, getBuildingBySearch, getDraftBuilding, createDraftBuilding, createBuilding, updateBuilding } from './Building';

import { login, logout, refreshToken } from './Authen';

import { getProfile, updateProfile } from './Profile';

import { getVehicleLicensePlate, searchVehicleLicensePlate } from './VehicleLicensePlate';

import { getParkingStatus, getParkingStatusById, createParking, carExit } from './Parking';

import { getParkingProblems, getProblems, createProblem, updateProblem, deleteProblem } from './Problems';

import { createPayment, updatePayment, getPaymentDetail } from './Payment';

import { getUserRoles, createUser, getUsers, updateUser, resetUserPassword } from './User';

import { getMembershipPackage, createMembership, getMembershipDetail, updateMembership, getTenants, createTenant, updateTenant } from './Membership';

import { getCompany } from './Company';

import {
  searchVehiclePlateOrCompanyNameInBuilding,
  searchVehiclePlateOrParkingRefInOperationReport,
  searchVehicleType,
  accountingSearchVehiclePlateOrReferenceCode,
  searchVehiclePlate,
  searchCompanyName,
  searchMemberName,
} from './Search';

import { errorMessage } from './Error';

import { iotDevices, publishIoTInformation } from './IoT';

import { 
  buildingParkingFeeModelCar, 
  buildingParkingFeeModelMotorcycle , 
  buildingInformation ,
  redemptionModelInformation, 
  configCommon, 
  config,
  buildingContent,
  buildingTenant,
  buildingIotDevice,
  buildingParkingDayConfig,
  currentBuildingDataPath,
} from './CreateBuilding';

import { getParkingDayConfig, updateParkingDayConfig, createParkingDayConfig } from './ParkingDayConfig';

export default combineReducers({
  // report
  getAccountingReports,
  exportAccountingReports,
  getParkingReport,
  exportOperationReports,
  getMembershipReport,
  // building
  getBuilding,
  getBuildingByRefNo,
  getBuildingBySearch,
  getDraftBuilding,
  createDraftBuilding,
  createBuilding,
  updateBuilding,
  // authen
  login,
  logout,
  refreshToken,
  // profile
  getProfile,
  updateProfile,
  // car plate
  getVehicleLicensePlate,
  searchVehicleLicensePlate,
  // parking
  getParkingStatus,
  getParkingStatusById,
  createParking,
  carExit,
  // problems
  getParkingProblems,
  getProblems,
  createProblem,
  updateProblem,
  deleteProblem,
  // payment
  createPayment,
  updatePayment,
  getPaymentDetail,
  // user
  getUsers,
  getUserRoles,
  createUser,
  updateUser,
  resetUserPassword,
  // membership
  getMembershipPackage,
  createMembership,
  getMembershipDetail,
  updateMembership,
  getTenants,
  createTenant,
  updateTenant,
  // company
  getCompany,
  // search
  searchVehiclePlateOrCompanyNameInBuilding,
  accountingSearchVehiclePlateOrReferenceCode,
  searchVehiclePlateOrParkingRefInOperationReport,
  searchVehicleType,
  searchVehiclePlate,
  searchCompanyName,
  searchMemberName,
  // error message
  errorMessage,
  // IoT
  iotDevices,
  publishIoTInformation,
  // Create building
  buildingParkingFeeModelCar,
  buildingParkingFeeModelMotorcycle,
  buildingInformation,
  redemptionModelInformation,
  configCommon,
  config,
  buildingContent,
  buildingTenant,
  buildingIotDevice,
  buildingParkingDayConfig,
  currentBuildingDataPath,
  // Parking day config
  getParkingDayConfig,
  updateParkingDayConfig,
  createParkingDayConfig,
});
